export const Portals = {
  HDA: {
    hostPlatformName: 'Healthdirect Australia',
  },
};
